export const ANALYST_COVERAGE_PATH = 'analyst-coverage'
export const MARKET_CAP_PATH = 'market-cap'
export const SECTOR_PATH = 'sector'
